import { call, put } from 'redux-saga/effects'
import { PayloadAction } from '@reduxjs/toolkit'
import apiMiddleware from 'services/api_middleware'
import app_config from 'config/app_config'

import { onOpenNotification } from 'redux/notification/reducer'
import {
	getUserSuccess,
	setUserTeamSubscriptionFailure,
	setUserTeamSubscriptionSuccess,
} from 'redux/user/reducer'
import { IUser, SubscriptionEnumType } from './types'

export function* setUserTeamSubscription({ payload }: PayloadAction<{ subscription: SubscriptionEnumType }>) {
	try {
		const {
			data,
			message,
		}: {
			data: { user: IUser }
			message: string
		} = yield call(apiMiddleware, {
			url: app_config.services.updateTeamSubscription,
			method: 'POST',
			data: payload,
		})

		yield put(getUserSuccess(data.user))
		yield put(setUserTeamSubscriptionSuccess())

		yield put(
			onOpenNotification({
				message,
				notificationType: 'success',
			})
		)
	} catch (e) {
		const error = e as { message: string }

		yield put(
			onOpenNotification({
				message: error.message,
				notificationType: 'error',
			})
		)

		yield put(setUserTeamSubscriptionFailure())
	}
}
